// Source of truth for i18n keys; ru.ts and en.ts must define exactly the same keys.
// Copy follows design/*.dc.html (owner decision: mockups are the reference text).
// Uzbek Latin: ʻ (U+02BB) in oʻ/gʻ, ʼ (U+02BC) for tutuq belgisi (maʼno). Never ASCII '.
export const uz = {
  'lang.uz': 'Oʻzbekcha',
  'lang.ru': 'Русский',
  'lang.en': 'English',

  'greeting.morning': 'Xayrli tong, {name}',
  'greeting.day': 'Xayrli kun, {name}',
  'greeting.evening': 'Xayrli kech, {name}',
  'greeting.night': 'Xayrli tun, {name}',

  'home.title': 'Ertaklar',
  'home.profile': 'Profil',
  'home.tonight': 'Bugungi ertak',
  'home.listen': 'Tinglash',
  'home.continue': 'Davom ettirish',
  'home.minutesLeft': '{count} daq qoldi',
  'home.all': 'Barcha ertaklar',
  'home.language': 'Ertak tili',

  'quota.free': '{count} ta bepul',
  'quota.freeLeft': '{count} ta bepul qoldi',
  'quota.none': 'Bepul tugadi',
  'quota.premium': 'Premium',

  'story.minutes': '{count} daq',
  'story.play': 'Tinglash',
  'story.playing': 'Ijro etilmoqda',
  'story.listened': 'Tinglangan',
  'story.locked': 'Premium',
  'story.draft': 'Qoralama',

  'player.label': 'Pleer',
  'player.close': 'Yopish',
  'player.more': 'Koʻproq',
  'player.tonight': 'Bugungi ertak',
  'player.story': 'Ertak',
  'player.withText': 'Matn bilan tinglash',
  'player.ended': 'Ertak tugadi',
  'player.meta': 'Ertak · {minutes} daq · {ageMin}–{ageMax} yosh',
  'player.textCard': 'Ertak matni',
  'player.textCardHint': 'Matnni ochish',
  'player.play': 'Tinglash',
  'player.pause': 'Pauza',
  'player.back15': '15 soniya orqaga',
  'player.forward15': '15 soniya oldinga',
  'player.prev': 'Oldingi ertak',
  'player.next': 'Keyingi ertak',
  'player.seek': 'Ertak vaqti',
  'player.buffering': 'Yuklanmoqda…',
  'player.speed': 'Tezlik',
  'player.timer': 'Taymer',
  'player.timerOff': 'Oʻchiq',
  'player.timerEnd': 'Oxirigacha',
  'player.text': 'Matn',
  'player.textLoading': 'Matn yuklanmoqda…',
  'player.textError': 'Matnni yuklab boʻlmadi',
  'player.error': 'Ovoz yuklanmadi. Internetni tekshiring.',
  'player.retrying': 'Ulanish uzildi — qayta urinyapmiz…',

  'menu.share': 'Ulashish',
  'menu.shareText': 'Fonus Ertak — bolalar uchun har kecha yangi audio ertak 🌙',
  'menu.storyLang': 'Ertak tili',
  'menu.textSize': 'Matn oʻlchami',
  'menu.textSizeNormal': 'Oddiy',
  'menu.textSizeLarge': 'Katta',
  'menu.report': 'Muammo haqida xabar berish',
  'menu.cancel': 'Bekor qilish',

  'sleep.title': 'Uyqu taymeri',
  'sleep.hint': 'Vaqt tugaganda ertak sekin pasayib toʻxtaydi',
  'sleep.off': 'Oʻchiq',
  'sleep.minutes': '{count} daqiqa',
  'sleep.end': 'Ertak oxirigacha',
  'sleep.done': 'Tayyor',

  'night.title': 'Tun rejimi',
  'night.wake': 'Ekranni yoqish',
  'night.fade': 'Ertak sekin tugaydi · ovoz asta pasayadi',
  'night.plus5': '+5 daqiqa',
  'night.stop': 'Hozir toʻxtatish',

  'end.goodnight': 'Yaxshi tunlar, {name}!',
  'end.body': '“{title}” tugadi. Ertangi ertak {time} da keladi.',
  'end.next': 'Keyingi ertak',
  'end.stopHere': 'Shu yerda toʻxtatish',
  'end.pickOther': 'Boshqa ertak tanlash',

  'paywall.close': 'Yopish',
  'paywall.badge': 'Premium ertak',
  'paywall.title': 'Har kecha yangi ertak',
  'paywall.subStory': '“{title}” va barcha ertaklar Premiumʼda ochiladi.',
  'paywall.subGeneric': 'Barcha ertaklar Premiumʼda ochiladi.',
  // Former subscribers (premiumEndedAt set) see this instead of the newcomer copy.
  'paywall.expiredTitle': 'Obuna tugadi',
  'paywall.expiredSubtitle': 'Tinglashda davom etish uchun obunani yangilang',
  'paywall.valNightly': 'Har kecha yangi ertak',
  'paywall.valArchive': 'Barcha ertaklar arxivi',
  'paywall.valTextNight': 'Barcha ertaklar — matn va tun rejimi bilan',
  'paywall.plans': 'Tarif',
  'paywall.save': '{percent}% tejamkor',
  'plan.week': 'Hafta',
  'plan.month': 'Oy',
  'plan.year': 'Yil',
  'plan.perMonth': '{price} oyiga',
  'paywall.payClick': 'Click orqali toʻlash',
  'paywall.payPayme': 'Payme orqali toʻlash',
  'paywall.payStars': 'Telegram Stars bilan toʻlash',
  'paywall.payFake': 'Test toʻlov (dev)',
  'paywall.proof': '100 000+ oila allaqachon Fonus Kids bilan',
  // Honest until auto-renewal exists (owner decision): payments are one-off.
  'paywall.noAutoCharge': 'Avtomatik yechib olinmaydi',
  'paywall.how': 'Qanday ishlaydi',
  'paywall.stepToday': 'Bugun',
  'paywall.stepTodayBody': 'Premium darhol ochiladi',
  'paywall.stepTodayStory': 'Premium darhol ochiladi — “{title}” ham',
  'paywall.stepNightly': 'Har kecha {time}',
  'paywall.stepNightlyBody': 'Yangi ertak va yumshoq eslatma keladi',
  'paywall.stepRemind': 'Tugashiga 3 kun qolganda',
  'paywall.stepRemindBody': 'Telegramʼda oldindan eslatamiz',
  'paywall.restore': 'Obunani tiklash',
  'paywall.restoreNone': 'Faol obuna topilmadi — yordam chatiga yozing',
  'paywall.offer': 'Oferta',
  'paywall.privacy': 'Maxfiylik',

  'gate.title': 'Kattalar uchun',
  'gate.body': 'Toʻlovni davom ettirish uchun toʻgʻri javobni tanlang',
  'gate.wrong': 'Qayta urinib koʻring',
  'gate.cancel': 'Bekor qilish',

  'payment.checking': 'Holat avtomatik tekshirilmoqda',
  'payment.waitingTitle': 'Toʻlov tasdiqlanmoqda',
  'payment.waitingBody':
    '{provider} ilovasida toʻlovni tasdiqlang. Tasdiqlanishi bilan Premium oʻzi ochiladi.',
  'payment.pendingBody': 'Toʻlov hali tasdiqlanmadi. Birozdan keyin yana tekshiring.',
  'payment.stepCreated': 'Buyurtma yaratildi',
  'payment.stepConfirm': '{provider}ʼda tasdiqlash',
  'payment.stepUnlock': 'Premium ochiladi',
  'payment.order': '{provider} · buyurtma № {orderNo}',
  'payment.planWeek': 'Haftalik obuna',
  'payment.planMonth': 'Oylik obuna',
  'payment.planYear': 'Yillik obuna',
  'payment.open': '{provider} ilovasini ochish',
  'payment.check': 'Toʻlovni tekshirish',
  'payment.cancel': 'Bekor qilish',
  'payment.help': 'Yordam kerakmi?',
  'payment.successChip': 'Premium faol',
  'payment.successTitle': 'Yoqimli tushlar, {name}!',
  'payment.successBody': 'Endi har kecha yangi ertak va barcha ertaklar arxivi sizniki.',
  'payment.receipt': '{plan} · {price}',
  'payment.until': '{date} gacha · chek Telegramʼda',
  'payment.remind': 'Har kecha {time} da eslatish',
  'payment.remindSub': 'Uyqu odatini birga shakllantiramiz',
  'payment.listen': 'Ertakni tinglash',
  'payment.home': 'Bosh sahifaga',
  'payment.failedTitle': 'Toʻlov oʻtmadi',
  'payment.failedBody': 'Xavotir olmang — hisobingizdan pul yechilmadi.',
  'payment.why': 'Odatda sababi',
  'payment.reasonFunds': 'Kartada mablagʻ yetarli emas',
  'payment.reasonCancelled': 'Toʻlov {provider}ʼda bekor qilindi',
  'payment.reasonNetwork': 'Internet aloqasi uzildi',
  'payment.retry': 'Qayta urinish',
  'payment.support': 'Yordam chatiga yozish',

  'profile.title': 'Profil',
  'profile.close': 'Yopish',
  'profile.premium': 'Premium',
  'profile.active': 'Faol',
  'profile.planUntil': '{plan} · {date}gacha',
  'profile.planWeekly': 'Haftalik',
  'profile.planMonthly': 'Oylik',
  'profile.planYearly': 'Yillik',
  'profile.manage': 'Boshqarish',
  'profile.noPremium': 'Premium yoʻq',
  'profile.freeLeft': '{count} ta bepul ertak qoldi',
  'profile.ended': '{date}da tugadi',
  'profile.subscribe': 'Obuna boʻlish',
  'profile.settings': 'Sozlamalar',
  'profile.language': 'Til',
  'profile.reminder': 'Kechki eslatma',
  'profile.reminderAt': 'Har kuni {time} da',
  'profile.quality': 'Audio sifati',
  'profile.qualityHint': 'Tejamkor rejim mobil internetda kamroq trafik sarflaydi.',
  'profile.help': 'Yordam',
  'profile.support': 'Yordam chatiga yozish',
  'profile.version': 'Fonus Ertak {version} · Fonus Kids',

  'quality.auto': 'Avto',
  'quality.low': 'Tejamkor',
  'quality.high': 'Yuqori',

  'welcome.label': 'Xush kelibsiz',
  'welcome.chip': '{count} ta ertak bepul',
  'welcome.title': 'Har kuni yangi audio ertak',
  'welcome.body': 'Uxlashdan oldin bolangiz bilan tinglang — oʻzbek, rus va ingliz tillarida.',
  'welcome.start': 'Boshlash',

  'state.emptyTitle': 'Bu tilda hali ertak yoʻq',
  'state.emptyBody': 'Bu tildagi ertaklar tez orada qoʻshiladi. Hozircha oʻzbekcha tinglang.',
  'state.emptyCta': 'Oʻzbekchaga oʻtish',
  'state.emptyUzBody': 'Yangi ertaklar tez orada qoʻshiladi.',
  'state.offlineTitle': 'Internet yoʻq',
  'state.offlineBody': 'Ulanishni tekshiring — ertaklar sizni kutib turadi.',
  'state.retry': 'Qayta urinish',
  'state.errorTitle': 'Nimadir xato ketdi',
  'state.errorBody': 'Ertakni yuklab boʻlmadi. Birozdan keyin qayta urinib koʻring.',
  'state.reload': 'Qayta yuklash',
  'state.expiredTitle': 'Obuna muddati tugadi',
  'state.expiredBody': 'Premium {date}da tugadi. Yangilang — har kecha yangi ertak davom etadi.',
  'state.renew': 'Obunani yangilash',
  'state.later': 'Keyinroq',
  // initData older than 24 h (INIT_DATA_EXPIRED): the button calls Telegram.WebApp.close().
  'state.reopenTitle': 'Ilovani qaytadan oching',
  'state.reopenBody': 'Ilova uzoq vaqt ochiq qoldi. Uni yoping va bot orqali qaytadan oching.',
  'state.reopenButton': 'Yopish',

  'toast.langChanged': 'Til oʻzgartirildi',
  'toast.slowNetwork': 'Internet sekin — tejamkor sifat',
  'toast.offline': 'Internet yoʻq — saqlangan ertaklar koʻrsatilmoqda',
  'toast.loading': 'Yuklanmoqda',

  'bot.welcome':
    'Assalomu alaykum, {name}! 🌙\nHar kuni kechqurun yangi ertak. Tinglash uchun tugmani bosing.',
  'bot.open': 'Ertaklarni ochish',
  'bot.help':
    'Fonus Ertak — bolalar uchun audio ertaklar.\n/start — ertaklarni ochish\n/language — tilni tanlash\n/subscription — obuna holati\n/help — yordam',
  /** Chat menu button (setChatMenuButton per chat, in the profile language). */
  'bot.menuButton': 'Ertaklar',
  'bot.cmdStart': 'Ertaklarni ochish',
  'bot.cmdHelp': 'Yordam',
  'bot.cmdLanguage': 'Tilni tanlash',
  'bot.cmdSubscription': 'Obuna holati',
  'bot.languagePick': 'Tilni tanlang:',
  'bot.languageSet': 'Til oʻzgartirildi: Oʻzbekcha',
  'bot.subActive': 'Premium faol: {date} gacha.\n{plan}',
  'bot.subNext': 'Keyingi davr: {plan}, {date}dan',
  'bot.subGranted': 'Premium faol: {date} gacha.',
  'bot.subNone': 'Premium yoʻq. Bepul ertaklar: {freeLeft} ta qoldi.',
  'bot.subEndedOn': 'Premium {date} kuni tugagan.',
  'bot.buy': 'Premium olish',
  'bot.renew': 'Uzaytirish',
  'bot.tonight': 'Bugungi ertak tayyor 🌙\n«{title}»',
  'bot.tonightNoTitle': 'Bugungi ertak tayyor 🌙',
  'bot.listen': 'Tinglash',
  'bot.subExpiring':
    'Premium {date} kuni tugaydi — {days} kun qoldi. Ertaklar toʻxtab qolmasligi uchun obunani uzaytiring.',
  'bot.subEndsToday':
    'Bugun Premiumning oxirgi kuni. Ertaklar toʻxtab qolmasligi uchun obunani uzaytiring.',
  'bot.subEnded': 'Premium bugun tugadi. Tinglashda davom etish uchun obunani uzaytiring.',
  'bot.receipt':
    'Toʻlov qabul qilindi ✅\nBuyurtma № {orderNo}\n{plan} · {price}\nPremium {date} gacha faol.',
  'admin.storyReady': '🆕 Yangi ertak tekshirishga tayyor: «{title}»\n{url}',
  'admin.ttsBudget':
    '⛔ Ovozlashtirish boshlanmadi: ElevenLabs kreditlari yetmaydi. Kerak ≈{need}, qoldi {remaining}; oy davomida {monthUsed} / {limit}.',
  'admin.ttsBudgetUnavailable':
    '⛔ Ovozlashtirish boshlanmadi: ElevenLabs balansini tekshirib boʻlmadi ({detail}).',
  'admin.contentFailed': '⚠️ «{type}» vazifasi xato bilan tugadi: {error}',
  'admin.newPayment': '💳 Yangi toʻlov № {orderNo}\n{plan} · {price} · {provider}',
  'admin.broadcastFailed': '⚠️ Kechki xabar: {failed} ta xato ({sent} yuborildi, {total} dan).',
  'admin.broadcastCrashed': '⚠️ Kechki xabar toʻxtadi: {error}',
  'admin.report':
    '📊 Hisobot, {date}\nYangi foydalanuvchilar: {newUsers}\nTinglaganlar: {listeners} · tinglashlar: {listens} ({completed} oxirigacha)\nToʻlovlar: {payments} · {revenue}\nFaol Premium: {premium}\nKechki xabar: {broadcast}',
  'admin.reportNoBroadcast': 'yuborilmagan',
  'admin.reportBroadcast': '{sent} yuborildi · {blocked} bloklagan · {failed} xato',
} as const;
